// extracted by mini-css-extract-plugin
export default {"headerTitle":"popularProducts_headerTitle__6FM7m","page":"popularProducts_page__zNENg","header":"popularProducts_header__o0z6g"};